import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from 'react'
// import { useInView } from 'react-intersection-observer'
import { m, LazyMotion, domAnimation } from "framer-motion"
import { MainContext } from "../../context/mainContext"
import { ErrorToast } from './errorToast'
import { imgUrlConverter, actionUrlConverter, alternateUrlConverter } from '../../util/util'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

export const CatalogList = ( { appData:{storedata}, appData:{customerdata} }) => {

    const [err, setErr] = useState(null)
    const mascotName = storedata?.schoolStoreHeroBannerData?.mascotName
    const productCatalog = customerdata?.filter(data=>data.contentType === 'ProductCatalog')
    const catalogsQty = storedata?.productCatalogs?.length
    const slickRef = useRef(null)
    const ctx = useContext(MainContext)
    /* const [ref, inView] = useInView({
        threshold: 0,
    }) */
    /* const [firstCardRef, firstCardInView] = useInView({
        threshold: 0,
    }) */
    const contactUs = <a href={`${window.location.protocol}//${window.location.hostname}/apps/shop/help/shared/customer_care_index.asp`}>contact us</a>
    const changeYourSchool = <a className='affiliate-school' href='#'>change your school</a>

    const itemsClassName = catalogsQty && catalogsQty > 3 ? '' : ` items-${catalogsQty}`
    
    const cardsClassName = useMemo(() => (i) => {
        if ((catalogsQty === 2) || (catalogsQty > 3 && i === 0) || (catalogsQty === 3 && i <= 1)) {
            return ' first'
        } else {
            return ''
        }
    }, [])

    const a11yMaker = useCallback(
        () => {
            const activeCards = slickRef.current.querySelectorAll('.slick-active')
            const inActiveCards = slickRef.current.querySelectorAll('.slick-slide.item:not(.slick-active)')
            Array.from(activeCards).forEach(el => {
                el.setAttribute("tabindex","0");
            });
            Array.from(inActiveCards).forEach(el => {
                el.setAttribute("tabindex","-1");
            });
        },
        [],
    )

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('error') && urlParams.get('error') === 'true') {
            switch (urlParams.get('errorFile')) {
                case 'no-product-error-specific.htm':
                    setErr({
                        case:1,
                        message: urlParams.get('errorProductName') 
                                ? <span>{urlParams.get('errorProductName')} are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                                : <span>Selected products are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-product-error.htm':
                    setErr({
                        case:2,
                        message: <span>Product is currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-group-error-specific.htm':
                    setErr({
                        case:3,
                        message: urlParams.get('errorGroupName') 
                                ? <span>{urlParams.get('errorGroupName')} are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                                : <span>Selected catalogs are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-group-error.htm':
                    setErr({
                        case:4,
                        message: <span>Product collection is currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case null:
                    setErr({
                        case:6,
                        message: <span>Our website encountered an unexpected error.We apologize for the inconvenience. Check to make sure you're at the right school. You can {changeYourSchool}, browse the products below, or {contactUs} for additional support.</span>
                    })
                    break;

                case 'inaccessible-product-error.htm':
                    setErr({
                        case:7,
                        message: <span>That item is inaccessible.Please sign in as the original owner of that item.</span>
                    })
                    break;

                case 'no-catalog-products-error.htm':
                    setErr({
                        case:8,
                        message: <span>Actual message: The product you looked for is not currently available for this school. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-customer-found.htm':
                    setErr({
                        case:9,
                        message: <span>Actual Message: Your school or group could not be found.We apologize for the inconvenience. Check to make sure you're at the right school. You can {changeYourSchool}, browse the products below, or {contactUs} for additional support.</span>
                    })
                    break;    
    
                default:
                    break;
            }
        }
        if (!storedata?.productCatalogs || storedata?.productCatalogs?.length === 0) {
            const affilate = document.cookie.replace(/(?:(?:^|.*;\s*)affiliateName\s*\=\s*([^;]*).*$)|^.*$/, "$1") + '|' + document.cookie.replace(/(?:(?:^|.*;\s*)affiliateIds\s*\=\s*([^;]*).*$)|^.*$/, "$1")
            const options = {
                method: "POST",
                mode: 'no-cors',
                headers: new Headers({'Content-Type': 'text/plain'}),
                body: 'There are no Jostens catalogs available for ' + affilate
            };

            fetch(actionUrlConverter('https://devwww.jostens.com/apps/store/report.mvc'), options)

            setErr({
                case:5,
                message: <span>There are currently no Jostens catalogs available for this school at this time. We apologize for the inconvinience.</span>
            })
        }
    }, [])

    const showXlDots = (catalogsQty > 4);
    const showLgDots = (catalogsQty > 4);
    const showMdDots = (catalogsQty > 3);
    const showSmDots = (catalogsQty > 2);
    let settings = {
        afterChange: a11yMaker,
        slidesToShow: catalogsQty > 4 ? 4 : catalogsQty,
        slidesToScroll: catalogsQty > 4 ? 4 : catalogsQty,
        arrows: showXlDots,
        dots: showXlDots,
        variableWidth: !Boolean(catalogsQty === 2),
        infinite: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    variableWidth: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: showMdDots,
                    arrows: false,
                    variableWidth: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: showMdDots,
                    arrows: showMdDots,
                    variableWidth: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: catalogsQty > 4 ? 4 : catalogsQty,
                    slidesToScroll: catalogsQty > 4 ? 4 : catalogsQty,
                    dots: showLgDots,
                    arrows: showLgDots,
                    variableWidth: false
                }
            }
            ,
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: catalogsQty > 4 ? 4 : catalogsQty,
                    slidesToScroll: catalogsQty > 4 ? 4 : catalogsQty,
                    dots: showXlDots,
                    arrows: showXlDots,
                    variableWidth: false
                }
            }
        ]
    }

	useEffect(() => {
        if(slickRef.current && slickRef.current.querySelector('.slick-slider')) {
            const root = document.documentElement
            const gridElementWidth = Number(slickRef.current.offsetWidth) / 5 - 10;
            root.style.setProperty('--slider-element-width', gridElementWidth + "px")
            root.style.setProperty('--slider-element-width-double', gridElementWidth * 2 + "px")
            
            const style = document.createElement("style");
            document.head.appendChild(style);
            style.sheet.insertRule('.slick-disabled{display:none !important;}', 0);

            a11yMaker()
        }
    }, [slickRef.current])

    const imgHandler = useCallback(
        (catOsr) => {
            let url
            if (productCatalog[0]?.images) {
                const cat = productCatalog[0].images.find(el => el.catalogOsr === catOsr)
                url = cat?.imageUrl
            }
            return url
        },
        [productCatalog]
    )

    const container = {
        show: {
          transition: {
            staggerChildren: 0.2
          }
        }
    }

    const product = {
        hidden: { opacity: 0 },
        show: 
            { 
                opacity: 1,
                transition: {
                    duration: 0.25
                }
            }
    }

    const cardClickHandler = useCallback(
        (e, catalog) => {
            e.stopPropagation()
            if (catalog.subCatalogs?.length) {
                ctx.openPopup({
                    class: 'small',
                    title: 'Select Your Collection',
                    content:<div className="list-group">
                                {
                                    catalog.subCatalogs.map( cat => <a key={cat.id} className="list-group-item" href={actionUrlConverter(cat.actionUrl)}><span>{cat.displayName}</span></a> )
                                }
                            </div>
                })
            } else {
                catalog.alternateUrl ? window.open(alternateUrlConverter(catalog.alternateUrl), '_blank', 'noopener,noreferrer') : window.open(actionUrlConverter(catalog.actionUrl), '_self')
            }
        },
        [],
    )

    const cardKeyPressHandler = useCallback(
        (e, catalog) => {
            console.log(e);
            if(e.key === 'Enter' || e.key === 'Space'){
                cardClickHandler(e, catalog)
            }
        },
        [],
    )

	return (
        <LazyMotion features={domAnimation}>
            <div 
                className={'product-categories' + itemsClassName} 
                // ref={ref}
            >
                <m.div 
                    className="container"
                    ref={slickRef} 
                    variants={container}
                    initial="hidden"
                    animate="show"
                >
                    { mascotName && storedata ? <h2>SHOW YOUR {mascotName} PRIDE</h2> : storedata ? <h2>SHOW YOUR PRIDE</h2> : null}
                    { err ? <ErrorToast message={err.message} /> : null}
                    { catalogsQty === 1 &&
                        storedata.productCatalogs.map((catalog) =>
                                <div class="banner item">
                                    <div class="img">
                                        <img src={imgHandler(catalog.catalogOsr) ? imgUrlConverter(imgHandler(catalog.catalogOsr)) : imgUrlConverter(catalog.imageUrl)} alt={catalog.displayName} />
                                    </div>
                                    <div class="overlay">
                                        <div class="inner">
                                            <h3>{catalog.displayName}</h3>
                                            <p>{catalog.description}</p>
                                            <div>
                                            <div href="#" onClick={(e)=>{cardClickHandler(e, catalog)}} className="btn btn-sm btn-white btn-white--ghost">Shop</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                    }
                    { catalogsQty > 1 && 
                        <Slider {...settings} className="carousel">
                            {storedata.productCatalogs.map((catalog, key) => 
                            <m.div
                                className={'item' + cardsClassName(key)}
                                style={{cursor: 'pointer'}}
                                onClick={(e)=>{cardClickHandler(e, catalog)}}
                                onKeyPress={(e)=>{cardKeyPressHandler(e, catalog)}}
                                key={`CatalogItem-${key}`}
                                variants={product}
                            >
                                <div className="img">
                                    <img src={imgHandler(catalog.catalogOsr) ? imgUrlConverter(imgHandler(catalog.catalogOsr)) : imgUrlConverter(catalog.imageUrl)} alt={catalog.displayName} />
                                </div>
                                <div className="overlay">
                                    <div className="inner">
                                        <h3>{catalog.displayName}</h3>
                                        <div className="btn btn-sm btn-white btn-white--ghost">Shop</div>
                                    </div>
                                </div>
                            </m.div>)
                            }
                        </Slider>
                    }
                </m.div>
            </div>
        </LazyMotion>
	)
}

export default CatalogList